import { ModalContext } from 'components/ModalContext';
import { useContext } from 'react';
import Modal, { ModalProps } from 'react-bootstrap/Modal';
import {
  FacebookShareButton,
  LineShareButton,
  TwitterShareButton,
  FacebookIcon,
  LineIcon,
  TwitterIcon,
} from 'react-share';

export const ShareModal = (props: ModalProps) => {
  const { close } = useContext(ModalContext);
  const url = window.location.href;
  const title =
    window.document
      ?.querySelector('meta[name="description"]')
      ?.getAttribute('content') || '';

  return (
    <Modal
      {...props}
      show
      onHide={close}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="h5">
          공유하기
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center justify-content-center p-3">
          <FacebookShareButton url={url} className="mx-3">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <LineShareButton url={url} title={title} className="mx-3">
            <LineIcon size={32} round />
          </LineShareButton>
          <TwitterShareButton url={url} title={title} className="mx-3">
            <TwitterIcon size={32} round />
          </TwitterShareButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};
